import { Component } from '@angular/core';

@Component({
  selector: 'svg-data-model',
  standalone: true,
  template: `
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor">
      <path
        d="m1.126 1.187v22.789l6.837 6.837h22.789v-29.626zm27.917 27.917h-19.941v-6.267h-6.267v-19.941h26.207v26.208zm-14.243-14.243v-3.988h2.279v3.988h3.988v2.279h-3.988v9.685h9.685v-9.685h-3.988v-2.279h3.988v-9.686h-9.685v3.988h-2.279v-3.988h-9.686v9.685h9.686zm10.255 10.255h-6.267v-6.267h6.267zm-6.267-18.232h6.267v6.267h-6.267zm-11.964 0h6.267v6.267h-6.267z" />
    </svg>
  `,
  styleUrl: './svg.style.scss',
})
export class SvgDataModelComponent {}
